import {combineReducers} from 'redux';
import Food from './Food/Module';
import Meal from './Meal/Module';
import SelfService from './SelfService/Module';
import DateFoodMeal from './DateFoodMeal/Module';
import Report from './Report/Module';
import Reserve from './Reserve/Module';
import Device from './Device/Module';
import FeedWrit from "./Writs/Module"

const reducers = combineReducers({
  Food,
  Meal,
  Report,
  Reserve,
  SelfService,
  DateFoodMeal,
  Device,
  FeedWrit
});

export default reducers;
